import { i18n } from '@/i18n'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('distributors.header'),
      path: 'configurations/distributors',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/distributors/details',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('clients.modules'),
          path: 'configurations/distributors/modules',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        // {
        //   name: i18n.t('distributors.template_clients'),
        //   path: 'configurations/distributors/template/clients',
        //   params,
        //   registerNavFromMenu: false,
        //   disabled: params.id === -1 || params.id === '-1',
        //   sc: [] // shorcuts
        // },
        {
          name: i18n.t('distributors.template_clients_personalization'),
          path: 'configurations/distributors/template/clientspersonalization',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('plantilla_pdf.header'),
          path: 'configurations/distributors/template/clientspdftemplate',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'configurations/distributors/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        }
      ]
    }
  ]
}
